<template>
  <div class="wheel-select-component-container">
    <div v-if="title" :class="`wheel-select-title ${error ? 'error' : ''}`">
      {{ title }}
    </div>
    <div :class="`selected-value ${error ? 'error' : ''}`" @click="isSelectorOpen = true">
      {{ selectedLabel }}
    </div>
    <div v-if="error" class="error-label">
      <img :src="publicUrl + '/input-error-icon.svg'" />
      <span>{{ error }}</span>
    </div>
    <BottomSheet :show="isSelectorOpen" @close-sheet="closeSelector">
      <div slot="body" class="wheel-selector-list">
        <div
          v-for="({value, label}, index) of options"
          :key="`${title}-${index}`"
          :class="selected === value ? 'select-option selected' : 'select-option'"
          @click="clickHandler(value, label)"
        >
          {{ label }}
        </div>
      </div>
    </BottomSheet>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop */

  export default {
    name: "WheelSelector",
    props: {
      disabled: {type: Boolean, default: false},
      options: {type: Array},
      name: {type: String},
      title: {type: String},
      selected: {type: [String, Number, Boolean]},
      error: {type: String}
    },
    data() {
      return {
        isSelectorOpen: false,
        publicUrl: process.env.PUBLIC_URL
      }
    },
    computed: {
      selectedLabel() {
        const {options = [], selected} = this
        const selectedOption = options && selected && options.find(({value}) => selected === value)
        return (selectedOption && selectedOption.label) || ""
      }
    },
    methods: {
      closeSelector() {
        this.isSelectorOpen = false
      },
      clickHandler(value, label) {
        this.selectedValue = value
        this.$emit("on-change-handler", value, label)
        this.closeSelector()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .wheel-select-component-container {
    margin: 20px 0;
    .wheel-select-title {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 600;
      &.error {
        color: #b00020;
        border-color: #b00020;
      }
    }

    .selected-value {
      padding: 10px 16px;
      border: 1px solid #b9c1bd;
      border-radius: 6px;
      font-size: 16px;
      cursor: pointer;
      height: 45px;
      position: relative;
      &::after {
        background-image: url("../assets/down-arrow.png");
        content: "";
        background-repeat: no-repeat;
        position: absolute;
        height: 14px;
        width: 14px;
        background-size: contain;
        right: 14px;
        top: 16px;
      }
      &.error {
        border: 2px solid #b00020;
        &:hover,
        &:focus {
          border: 2px solid #b00020;
        }
      }
    }
    .error-label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 14px;
      span {
        color: #b00020;
        font-weight: 600;
        font-size: 14px;
        padding-left: 6px;
      }
      img {
        height: 24px;
        width: 24px;
      }
    }
    .wheel-selector-list {
      max-height: 215px;
      overflow-y: scroll;
      padding: 20px 0;
      .select-option {
        font-size: 16px;
        padding: 10px 16px;
        font-weight: 600;
        cursor: pointer;
        border-bottom: 1px solid #e3e5e8;
        &.selected {
          background-color: #1ba26f;
          border-radius: 6px;
          color: #fff;
        }
      }
    }
  }
</style>
